import React from 'react';
import {diApi} from '@di-shared/api/di';
import type {ApiResponseEcoMileageResponseInfoLinkRtnData} from '@di-shared/api/di/__generated';
import MileageChallengeV2, {MileageChallengeUpdateV2} from '@di-shared/features/mileage/ecomileage-v2/MileageChallengeV2';
import MileageChallenge from '@di-shared/features/mileage/ecomileage/MileageChallenge';
import useOdometer from '@di-shared/features/mileage/useOdometer';
import {getQueryKey} from '@shared/queryKeyMap';
import {useSuspenseQuery} from '@tanstack/react-query';

/**
 * [2026-01-14:Jeyoung Lee] FIXME: 구제도가 완전히 사라지고 V1을 사용할 필요가 없다면 이 컴포넌트도 삭제되어야함(아마 2027년 2월)
 */
interface MileageChallengeSwitcherProps {
  vin: string;
}

function MileageChallengeSwitcher({vin}: MileageChallengeSwitcherProps) {
  const {data} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.ecoMileageController.getInfoLink), vin],
    queryFn: () => diApi.ecoMileageController.getInfoLink({vin}),
    select: (data: ApiResponseEcoMileageResponseInfoLinkRtnData) => data.data.rtn_data,
  });
  const {odometer, updatedDate} = useOdometer(vin);
  /**
   * MileageConditionalRenderer.tsx 에 케이스별 주석이 있음(drvng_stt_cd)
   * @link https://hmg.dooray.com/project/tasks/4208274598827184933
   */
  if (data.drvng_stt_cd === '032' || data.drvng_stt_cd === '022') {
    return <MileageChallenge vin={vin} />;
  }

  if (data.drvng_stt_cd === '063') {
    return <MileageChallengeV2 vin={vin} />;
  }

  console.warn(`Unexpected driving status: ${data.drvng_stt_cd}`);

  return (
    <MileageChallengeUpdateV2
      vin={vin}
      odometer={odometer}
      updatedDate={updatedDate}
    />
  );
}

export default MileageChallengeSwitcher;
